// payroll_v1: หน้าระบบเงินเดือน (3 tabs — ภาพรวม / รายการทั้งหมด / ตั้งค่าเงินเดือน)
import React, { useState, useEffect } from 'react';
import API from '../api';

const E = '/api/finance/employees';
const P = '/api/finance/payroll';
const FB = '/api/finance/businesses';

const money = function (n) { return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
const dt = function (s) { if (!s) return '-'; try { var d = new Date(s); return d.toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit' }) + ' ' + d.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return s; } };

const inp = { width: '100%', padding: 9, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, marginBottom: 12, boxSizing: 'border-box' };
const lbl = { fontSize: 12, color: '#64748b', fontWeight: 600 };
const btnPrimary = { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const btnSec = { background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const card = { background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };

const KIND_OPTIONS = [
  { value: 'salary', label: '💰 จ่ายเงินเดือน', effect: 1, financeType: 'expense' },
  { value: 'advance', label: '💸 เบิกล่วงหน้า', effect: -1, financeType: 'expense' },
  { value: 'bonus', label: '🎁 โบนัส/OT', effect: 1, financeType: 'expense' },
  { value: 'deduction', label: '⚠️ หัก (ขาด/สาย/ปกส.)', effect: -1, financeType: 'income' },
  { value: 'other', label: '📝 อื่นๆ (พิมพ์เอง)', effect: null, financeType: null }
];

const KIND_LABEL_MAP = { salary: 'เงินเดือน', advance: 'เบิก', bonus: 'โบนัส', deduction: 'หัก', other: 'อื่นๆ' };

// ============================================
// Main Page
// ============================================
export default function BillPayroll() {
  const [tab, setTab] = useState('overview');
  const [myPerms, setMyPerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(function () {
    API.get('/api/finance/permissions/my').then(function (r) { setMyPerms(r.data); }).catch(function () { setMyPerms({ is_owner: false, perms: {} }); }).finally(function () { setLoading(false); });
  }, []);

  var canSee = function () { if (!myPerms) return false; if (myPerms.is_owner) return true; return !!(myPerms.perms && myPerms.perms.payroll && myPerms.perms.payroll.view); };
  var canEdit = function () { if (!myPerms) return false; if (myPerms.is_owner) return true; return !!(myPerms.perms && myPerms.perms.payroll && myPerms.perms.payroll.edit); };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;
  if (!canSee()) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>คุณยังไม่มีสิทธิ์เข้าถึงระบบเงินเดือน<br/>กรุณาติดต่อเจ้าของบัญชี</div>;

  const tabs = [
    { key: 'overview', label: 'ภาพรวม' },
    { key: 'transactions', label: 'รายการทั้งหมด' },
    { key: 'settings', label: 'ตั้งค่าเงินเดือน' }
  ];

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 16px', color: '#0f172a' }}>👥 เงินเดือน</h1>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {tabs.map(function (t) {
          return (
            <button key={t.key} onClick={function () { setTab(t.key); }}
              style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
                background: tab === t.key ? '#10b981' : '#f1f5f9', color: tab === t.key ? '#fff' : '#475569' }}>
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === 'overview' ? <OverviewTab canEdit={canEdit()} />
        : tab === 'transactions' ? <TransactionsTab canEdit={canEdit()} />
        : <SettingsTab canEdit={canEdit()} />}
    </div>
  );
}

// ============================================
// Tab 1: Overview
// ============================================
function OverviewTab(props) {
  const [summary, setSummary] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [expanded, setExpanded] = useState({});  // empId → bool
  const [empTxns, setEmpTxns] = useState({});  // empId → rows
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const reload = function () {
    setLoading(true);
    Promise.all([
      API.get(E + '/summary/balances').then(function (r) { return r.data; }).catch(function () { return null; }),
      API.get(E).then(function (r) { return r.data; }).catch(function () { return []; })
    ]).then(function (results) {
      setSummary(results[0]); setEmployees(results[1] || []); setLoading(false);
    });
  };
  useEffect(reload, []);

  const toggleExpand = function (empId) {
    if (expanded[empId]) {
      setExpanded(Object.assign({}, expanded, { [empId]: false }));
      return;
    }
    if (!empTxns[empId]) {
      API.get(P + '?employee_id=' + empId + '&limit=20').then(function (r) {
        setEmpTxns(Object.assign({}, empTxns, { [empId]: r.data || [] }));
        setExpanded(Object.assign({}, expanded, { [empId]: true }));
      });
    } else {
      setExpanded(Object.assign({}, expanded, { [empId]: true }));
    }
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;
  const s = summary || { employees: {}, balance: {}, this_month: {} };
  const tm = s.this_month || {};

  return (
    <div>
      {/* Action button */}
      {props.canEdit && (
        <div style={{ marginBottom: 16 }}>
          <button onClick={function () { setShowForm(true); }} style={btnPrimary}>+ เพิ่มรายการ</button>
        </div>
      )}

      {/* Summary cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 16 }}>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>จ่ายเงินเดือนเดือนนี้</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', marginTop: 4 }}>{money((tm.salary || {}).total)}</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{(tm.salary || {}).count || 0} รายการ</div>
        </div>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>เบิกล่วงหน้าเดือนนี้</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#ef4444', marginTop: 4 }}>{money((tm.advance || {}).total)}</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{(tm.advance || {}).count || 0} รายการ</div>
        </div>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>พนักงานทั้งหมด</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', marginTop: 4 }}>{(s.employees && s.employees.total) || 0} คน</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
            ติดลบ {(s.employees && s.employees.negative_count) || 0} คน
          </div>
        </div>
      </div>

      {/* Employee list */}
      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 15, color: '#0f172a' }}>พนักงาน &amp; ยอดค้าง</h3>
          <span style={{ fontSize: 11, color: '#94a3b8' }}>ยอดสะสม (running balance — ไม่ reset)</span>
        </div>
        {employees.length === 0 ? <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>ยังไม่มีพนักงาน — เพิ่มได้ที่แท็บ "ตั้งค่าเงินเดือน"</div>
          : employees.map(function (e) {
            const initials = (e.name || '').slice(0, 2);
            const isNeg = e.balance < 0;
            const color = isNeg ? '#ef4444' : (e.balance > 0 ? '#10b981' : '#94a3b8');
            return (
              <div key={e.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                <div onClick={function () { toggleExpand(e.id); }}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 32, height: 32, borderRadius: '50%', background: isNeg ? '#fee2e2' : '#dcfce7', color: isNeg ? '#991b1b' : '#166534', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{initials}</div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{e.name}</div>
                      <div style={{ fontSize: 11, color: '#94a3b8' }}>
                        {(e.salaries || []).map(function (sal) {
                          return sal.business_name + ' ' + (sal.default_salary !== null ? money(sal.default_salary) : (sal.salary_note || '-'));
                        }).join(' · ') || 'ยังไม่ตั้งเงินเดือน'}
                      </div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: color }}>{e.balance > 0 ? '+' : ''}{money(e.balance)}</div>
                    <div style={{ fontSize: 10, color: '#94a3b8' }}>{isNeg ? 'เบิกเกิน' : 'ยอดค้าง'} · {e.txn_count} รายการ</div>
                  </div>
                </div>
                {expanded[e.id] && (
                  <div style={{ background: '#f8fafc', borderRadius: 8, padding: 12, marginBottom: 10 }}>
                    {(empTxns[e.id] || []).length === 0 ? <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, padding: 8 }}>ยังไม่มีรายการ</div>
                      : (
                        <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                          <thead><tr style={{ textAlign: 'left', color: '#94a3b8', fontSize: 10 }}>
                            <th style={{ padding: '4px 6px', fontWeight: 500 }}>วันที่</th>
                            <th style={{ padding: '4px 6px', fontWeight: 500 }}>ประเภท</th>
                            <th style={{ padding: '4px 6px', fontWeight: 500 }}>ธุรกิจ</th>
                            <th style={{ padding: '4px 6px', fontWeight: 500 }}>หมายเหตุ</th>
                            <th style={{ padding: '4px 6px', fontWeight: 500, textAlign: 'right' }}>จำนวน</th>
                          </tr></thead>
                          <tbody>
                            {(empTxns[e.id] || []).map(function (t) {
                              /* payroll_v2 patch: null-safe transaction */
                              var label = t.custom_label || KIND_LABEL_MAP[t.kind] || t.kind;
                              var sign = t.balance_effect === 1 ? '+' : '-';
                              var c = t.balance_effect === 1 ? '#10b981' : '#ef4444';
                              var txn = t.transaction || {};
                              var occurredAt = txn.occurred_at || t.created_at;
                              var amt = t.amount;
                              return (
                                <tr key={t.id} style={{ borderTop: '1px solid #e2e8f0' }}>
                                  <td style={{ padding: '6px', color: '#64748b' }}>{dt(occurredAt)}</td>
                                  <td style={{ padding: '6px' }}>{label}{t.no_finance ? <span style={{ marginLeft: 6, fontSize: 9, background: '#fef3c7', color: '#92400e', padding: '1px 5px', borderRadius: 4 }}>ไม่ลง finance</span> : null}</td>
                                  <td style={{ padding: '6px' }}>{t.business.name}</td>
                                  <td style={{ padding: '6px', color: '#64748b' }}>{txn.note || '-'}</td>
                                  <td style={{ padding: '6px', textAlign: 'right', color: c, fontWeight: 600 }}>{sign}{money(amt)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )
                    }
                  </div>
                )}
              </div>
            );
          })
        }
      </div>

      {showForm && <PayrollFormModal onClose={function () { setShowForm(false); }} onSaved={function () { setShowForm(false); reload(); setEmpTxns({}); }} />}
    </div>
  );
}

// ============================================
// Tab 2: Transactions list
// ============================================
function TransactionsTab(props) {
  const [rows, setRows] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [filter, setFilter] = useState({ employee_id: '', kind: '' });
  const [includeCanceled, setIncludeCanceled] = useState(false); /* payroll_v2 patch */
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const reload = function () {
    setLoading(true);
    var qs = [];
    if (filter.employee_id) qs.push('employee_id=' + encodeURIComponent(filter.employee_id));
    if (filter.kind) qs.push('kind=' + encodeURIComponent(filter.kind));
    if (includeCanceled) qs.push('include_canceled=true'); /* payroll_v2 patch */
    qs.push('limit=200');
    API.get(P + '?' + qs.join('&')).then(function (r) { setRows(r.data || []); }).catch(function () { setRows([]); }).finally(function () { setLoading(false); });
  };
  useEffect(reload, [filter, includeCanceled]); /* payroll_v2 patch */
  useEffect(function () { API.get(E).then(function (r) { setEmployees(r.data || []); }).catch(function () {}); }, []);

  const remove = function (id) {
    if (!window.confirm('ลบรายการนี้? รายการ finance จะถูกลบด้วย')) return;
    API.delete(P + '/' + id).then(reload).catch(function (e) { alert((e.response && e.response.data && e.response.data.error) || 'ลบไม่สำเร็จ'); });
  };

  return (
    <div>
      {props.canEdit && (
        <div style={{ marginBottom: 16 }}>
          <button onClick={function () { setShowForm(true); }} style={btnPrimary}>+ เพิ่มรายการ</button>
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <select value={filter.employee_id} onChange={function (e) { setFilter(Object.assign({}, filter, { employee_id: e.target.value })); }} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13 }}>
          <option value="">ทุกพนักงาน</option>
          {employees.map(function (emp) { return <option key={emp.id} value={emp.id}>{emp.name}</option>; })}
        </select>
        <select value={filter.kind} onChange={function (e) { setFilter(Object.assign({}, filter, { kind: e.target.value })); }} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13 }}>
          <option value="">ทุกประเภท</option>
          {KIND_OPTIONS.map(function (k) { return <option key={k.value} value={k.value}>{k.label}</option>; })}
        </select>
        {/* payroll_v2 patch: canceled toggle */}
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13, color: '#64748b' }}>
          <input type="checkbox" checked={includeCanceled} onChange={function (e) { setIncludeCanceled(e.target.checked); }} />
          <span>แสดงรายการที่ยกเลิก</span>
        </label>
      </div>

      <div style={card}>
        {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>
          : rows.length === 0 ? <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>ไม่พบรายการ</div>
          : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
                <thead><tr style={{ textAlign: 'left', color: '#94a3b8', fontSize: 11, borderBottom: '1px solid #e2e8f0' }}>
                  <th style={{ padding: '8px 6px', fontWeight: 500 }}>วันที่</th>
                  <th style={{ padding: '8px 6px', fontWeight: 500 }}>พนักงาน</th>
                  <th style={{ padding: '8px 6px', fontWeight: 500 }}>ประเภท</th>
                  <th style={{ padding: '8px 6px', fontWeight: 500 }}>ธุรกิจ</th>
                  <th style={{ padding: '8px 6px', fontWeight: 500 }}>หมายเหตุ</th>
                  <th style={{ padding: '8px 6px', fontWeight: 500, textAlign: 'right' }}>จำนวน</th>
                  {props.canEdit && <th style={{ padding: '8px 6px', fontWeight: 500 }}></th>}
                </tr></thead>
                <tbody>
                  {rows.map(function (t) {
                    /* payroll_v2 patch: null-safe + canceled styling */
                    var label = t.custom_label || KIND_LABEL_MAP[t.kind] || t.kind;
                    var sign = t.balance_effect === 1 ? '+' : '-';
                    var isCanceled = !!t.canceled_at;
                    var c = isCanceled ? '#94a3b8' : (t.balance_effect === 1 ? '#10b981' : '#ef4444');
                    var txn = t.transaction || {};
                    var occurredAt = txn.occurred_at || t.created_at;
                    var amt = t.amount;
                    var rowStyle = { borderBottom: '1px solid #f1f5f9' };
                    if (isCanceled) { rowStyle.opacity = 0.5; rowStyle.textDecoration = 'line-through'; }
                    return (
                      <tr key={t.id} style={rowStyle}>
                        <td style={{ padding: '8px 6px', color: '#64748b' }}>{dt(occurredAt)}</td>
                        <td style={{ padding: '8px 6px', fontWeight: 600 }}>{t.employee.name}</td>
                        <td style={{ padding: '8px 6px' }}>
                          {label}
                          {t.no_finance ? <span style={{ marginLeft: 6, fontSize: 10, background: '#fef3c7', color: '#92400e', padding: '1px 6px', borderRadius: 4 }}>ไม่ลง finance</span> : null}
                          {isCanceled ? <span style={{ marginLeft: 6, fontSize: 10, background: '#fee2e2', color: '#991b1b', padding: '1px 6px', borderRadius: 4 }}>ยกเลิกแล้ว</span> : null}
                        </td>
                        <td style={{ padding: '8px 6px', color: '#64748b' }}>{t.business.name}</td>
                        <td style={{ padding: '8px 6px', color: '#64748b' }}>{txn.note || '-'}</td>
                        <td style={{ padding: '8px 6px', textAlign: 'right', color: c, fontWeight: 600 }}>{sign}{money(amt)}</td>
                        {props.canEdit && <td style={{ padding: '8px 6px' }}>
                          {!isCanceled && <button onClick={function () { remove(t.id); }} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12 }}>ลบ</button>}
                        </td>}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
        }
      </div>

      {showForm && <PayrollFormModal onClose={function () { setShowForm(false); }} onSaved={function () { setShowForm(false); reload(); }} />}
    </div>
  );
}

// ============================================
// Tab 3: Settings (employees + salaries)
// ============================================
function SettingsTab(props) {
  const [employees, setEmployees] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEmpForm, setShowEmpForm] = useState(false);
  const [editingEmp, setEditingEmp] = useState(null);
  const [salaryEdit, setSalaryEdit] = useState(null); // {empId, bizId, current}

  const reload = function () {
    setLoading(true);
    Promise.all([
      API.get(E).then(function (r) { return r.data; }).catch(function () { return []; }),
      API.get(FB).then(function (r) { return r.data; }).catch(function () { return []; })
    ]).then(function (results) {
      setEmployees(results[0] || []); setBusinesses(results[1] || []); setLoading(false);
    });
  };
  useEffect(reload, []);

  const removeEmp = function (e) {
    if (!window.confirm('ลบพนักงาน "' + e.name + '"? (จะลบได้ก็ต่อเมื่อยังไม่มีรายการ)')) return;
    API.delete(E + '/' + e.id).then(reload).catch(function (err) { alert((err.response && err.response.data && err.response.data.error) || 'ลบไม่สำเร็จ'); });
  };
  const toggleEmp = function (e) { API.patch(E + '/' + e.id + '/toggle').then(reload).catch(function () {}); };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>;

  return (
    <div>
      {props.canEdit && (
        <div style={{ marginBottom: 16 }}>
          <button onClick={function () { setEditingEmp(null); setShowEmpForm(true); }} style={btnPrimary}>+ เพิ่มพนักงาน</button>
        </div>
      )}

      <div style={card}>
        <h3 style={{ margin: '0 0 12px', fontSize: 15, color: '#0f172a' }}>รายชื่อพนักงาน</h3>
        {employees.length === 0 ? <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>ยังไม่มีพนักงาน</div>
          : employees.map(function (e) {
            return (
              <div key={e.id} style={{ borderTop: '1px solid #f1f5f9', padding: '12px 0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <div>
                    <span style={{ fontWeight: 600, fontSize: 14, color: e.is_active ? '#0f172a' : '#94a3b8' }}>{e.name}</span>
                    {!e.is_active && <span style={{ marginLeft: 8, fontSize: 11, color: '#94a3b8' }}>(ปิดใช้งาน)</span>}
                    {e.note && <span style={{ marginLeft: 8, fontSize: 12, color: '#64748b' }}>· {e.note}</span>}
                  </div>
                  {props.canEdit && (
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={function () { setEditingEmp(e); setShowEmpForm(true); }} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: 12 }}>แก้ไข</button>
                      <button onClick={function () { toggleEmp(e); }} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 12 }}>{e.is_active ? 'ปิดใช้งาน' : 'เปิดใช้งาน'}</button>
                      <button onClick={function () { removeEmp(e); }} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12 }}>ลบ</button>
                    </div>
                  )}
                </div>
                <div style={{ paddingLeft: 12, fontSize: 12, color: '#64748b' }}>
                  <div style={{ marginBottom: 4, fontWeight: 600 }}>เงินเดือนต่อธุรกิจ:</div>
                  {businesses.map(function (b) {
                    var sal = (e.salaries || []).find(function (s) { return s.business_id === b.id; });
                    return (
                      <div key={b.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0' }}>
                        <span style={{ minWidth: 120 }}>{b.name}</span>
                        <span style={{ flex: 1, color: sal ? '#0f172a' : '#94a3b8' }}>
                          {sal ? (sal.default_salary !== null ? money(sal.default_salary) + ' บาท' : '') : 'ยังไม่ตั้ง'}
                          {sal && sal.salary_note ? ' (' + sal.salary_note + ')' : ''}
                        </span>
                        {props.canEdit && (
                          <button onClick={function () { setSalaryEdit({ empId: e.id, bizId: b.id, current: sal }); }} style={{ background: 'none', border: '1px solid #e2e8f0', borderRadius: 6, padding: '2px 8px', cursor: 'pointer', fontSize: 11, color: '#475569' }}>{sal ? 'แก้' : 'ตั้ง'}</button>
                        )}
                      </div>
                    );
                  })}
                  {businesses.length === 0 && <div style={{ color: '#94a3b8' }}>(ยังไม่มีธุรกิจ)</div>}
                </div>
              </div>
            );
          })
        }
      </div>

      {showEmpForm && <EmployeeFormModal editing={editingEmp} onClose={function () { setShowEmpForm(false); }} onSaved={function () { setShowEmpForm(false); reload(); }} />}
      {salaryEdit && <SalaryFormModal data={salaryEdit} onClose={function () { setSalaryEdit(null); }} onSaved={function () { setSalaryEdit(null); reload(); }} />}
    </div>
  );
}

// ============================================
// Modal: Payroll form (add transaction)
// ============================================
function PayrollFormModal(props) {
  /* payroll_v2 patch: no_finance defaults to false */
  const [form, setForm] = useState({ kind: 'salary', amount: '', employee_id: '', business_id: '', note: '', custom_label: '', finance_type: 'expense', balance_effect: 1, no_finance: false });
  const [employees, setEmployees] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(function () {
    API.get(E + '?active=true').then(function (r) { setEmployees(r.data || []); }).catch(function () {});
    API.get(FB).then(function (r) { setBusinesses(r.data || []); }).catch(function () {});
  }, []);

  const save = function () {
    setErr('');
    if (!form.employee_id) { setErr('กรุณาเลือกพนักงาน'); return; }
    if (!form.business_id) { setErr('กรุณาเลือกธุรกิจ'); return; }
    var amt = Number(form.amount);
    if (!isFinite(amt) || amt <= 0) { setErr('จำนวนเงินต้องมากกว่า 0'); return; }
    if (form.kind === 'other' && (!form.custom_label || !form.custom_label.trim())) { setErr('กรุณาระบุชื่อรายการ'); return; }
    setSaving(true);
    var payload = {
      employee_id: form.employee_id, business_id: form.business_id,
      kind: form.kind, amount: amt, note: form.note || null
    };
    if (form.kind === 'other') {
      payload.custom_label = form.custom_label;
      payload.balance_effect = Number(form.balance_effect);
      /* payroll_v2 patch: include no_finance + only send finance_type when finance is involved */
      payload.no_finance = !!form.no_finance;
      if (!form.no_finance) payload.finance_type = form.finance_type;
    }
    API.post(P, payload).then(props.onSaved)
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };

  return (
    <ModalShell title="เพิ่มรายการเงินเดือน" onClose={props.onClose}>
      <label style={lbl}>ประเภท</label>
      <select value={form.kind} onChange={function (e) { setForm(Object.assign({}, form, { kind: e.target.value })); }} style={inp}>
        {KIND_OPTIONS.map(function (k) { return <option key={k.value} value={k.value}>{k.label}</option>; })}
      </select>

      {form.kind === 'other' && (
        <>
          <label style={lbl}>ชื่อรายการ <span style={{ color: '#ef4444' }}>*</span></label>
          <input value={form.custom_label} onChange={function (e) { setForm(Object.assign({}, form, { custom_label: e.target.value })); }} style={inp} placeholder="เช่น เงินช่วยเหลือ, ค่ารักษา" />

          {/* payroll_v2 patch: balance_effect radio (always required for kind=other) */}
          <label style={lbl}>ผลกับยอดพนักงาน</label>
          <div style={{ display: 'flex', gap: 12, marginTop: 4, marginBottom: 12 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
              <input type="radio" name="effect" checked={form.balance_effect === 1 || form.balance_effect === '1'} onChange={function () { setForm(Object.assign({}, form, { balance_effect: 1 })); }} />
              <span>+ เพิ่ม yod พนักงาน</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
              <input type="radio" name="effect" checked={form.balance_effect === -1 || form.balance_effect === '-1'} onChange={function () { setForm(Object.assign({}, form, { balance_effect: -1 })); }} />
              <span>- ลด yod พนักงาน</span>
            </label>
          </div>

          {/* payroll_v2 patch: checkbox "ลงในระบบการเงินด้วย" (default unchecked) */}
          <div style={{ marginBottom: 12, padding: '10px 12px', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer', fontSize: 13 }}>
              <input type="checkbox" style={{ marginTop: 3 }} checked={!!form.no_finance ? false : !!form.finance_type_enabled} onChange={function (e) { setForm(Object.assign({}, form, { finance_type_enabled: e.target.checked, no_finance: !e.target.checked })); }} />
              <div>
                <div style={{ fontWeight: 600, color: '#0f172a' }}>ลงในระบบการเงินด้วย</div>
                <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>ถ้าไม่ติ๊ก = ปรับเฉพาะ yod พนักงาน ไม่กระทบ finance</div>
              </div>
            </label>

            {!form.no_finance && (
              <div style={{ marginTop: 10, paddingLeft: 24 }}>
                <label style={Object.assign({}, lbl, { fontSize: 11 })}>ลงเป็นในระบบการเงิน</label>
                <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12 }}>
                    <input type="radio" name="ftype" checked={form.finance_type === 'expense'} onChange={function () { setForm(Object.assign({}, form, { finance_type: 'expense' })); }} />
                    <span>รายจ่าย (เงินออก)</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12 }}>
                    <input type="radio" name="ftype" checked={form.finance_type === 'income'} onChange={function () { setForm(Object.assign({}, form, { finance_type: 'income' })); }} />
                    <span>รายรับ (เงินเข้า)</span>
                  </label>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <label style={lbl}>พนักงาน</label>
      <select value={form.employee_id} onChange={function (e) { setForm(Object.assign({}, form, { employee_id: e.target.value })); }} style={inp}>
        <option value="">— เลือกพนักงาน —</option>
        {employees.map(function (e) { return <option key={e.id} value={e.id}>{e.name}</option>; })}
      </select>

      <label style={lbl}>ธุรกิจ</label>
      <select value={form.business_id} onChange={function (e) { setForm(Object.assign({}, form, { business_id: e.target.value })); }} style={inp}>
        <option value="">— เลือกธุรกิจ —</option>
        {businesses.map(function (b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
      </select>

      <label style={lbl}>จำนวนเงิน</label>
      <input type="number" value={form.amount} onChange={function (e) { setForm(Object.assign({}, form, { amount: e.target.value })); }} style={inp} placeholder="0.00" />

      <label style={lbl}>หมายเหตุ (ไม่บังคับ)</label>
      <input value={form.note} onChange={function (e) { setForm(Object.assign({}, form, { note: e.target.value })); }} style={inp} placeholder="เช่น เงินเดือน พ.ค.69" />

      {/* payroll_v2 patch: conditional info note */}
      {(form.kind !== 'other' || !form.no_finance) ? (
        <div style={{ padding: '8px 10px', background: '#f0f9ff', borderRadius: 8, fontSize: 11, color: '#0369a1', marginBottom: 12 }}>
          ℹ️ รายการนี้จะถูกลงในระบบการเงินอัตโนมัติ (เป็นรายรับ/รายจ่าย)
        </div>
      ) : (
        <div style={{ padding: '8px 10px', background: '#fef3c7', borderRadius: 8, fontSize: 11, color: '#92400e', marginBottom: 12 }}>
          ⚠️ รายการนี้จะลงเฉพาะระบบเงินเดือน ไม่กระทบระบบการเงิน
        </div>
      )}

      {err && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 8 }}>{err}</div>}

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button onClick={props.onClose} style={btnSec} disabled={saving}>ยกเลิก</button>
        <button onClick={save} style={btnPrimary} disabled={saving}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
      </div>
    </ModalShell>
  );
}

// ============================================
// Modal: Employee form (create/edit)
// ============================================
function EmployeeFormModal(props) {
  const [form, setForm] = useState(props.editing || { name: '', note: '' });
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const save = function () {
    setErr('');
    if (!form.name || !form.name.trim()) { setErr('กรุณากรอกชื่อ'); return; }
    setSaving(true);
    var p = props.editing ? API.put(E + '/' + props.editing.id, form) : API.post(E, form);
    p.then(props.onSaved)
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };

  return (
    <ModalShell title={props.editing ? 'แก้ไขพนักงาน' : 'เพิ่มพนักงาน'} onClose={props.onClose}>
      <label style={lbl}>ชื่อพนักงาน</label>
      <input value={form.name || ''} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} style={inp} />
      <label style={lbl}>หมายเหตุ (ไม่บังคับ)</label>
      <input value={form.note || ''} onChange={function (e) { setForm(Object.assign({}, form, { note: e.target.value })); }} style={inp} />
      {err && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 8 }}>{err}</div>}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button onClick={props.onClose} style={btnSec} disabled={saving}>ยกเลิก</button>
        <button onClick={save} style={btnPrimary} disabled={saving}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
      </div>
    </ModalShell>
  );
}

// ============================================
// Modal: Salary form (upsert salary per business)
// ============================================
function SalaryFormModal(props) {
  const init = props.data.current || {};
  const [form, setForm] = useState({
    default_salary: init.default_salary !== null && init.default_salary !== undefined ? String(init.default_salary) : '',
    salary_note: init.salary_note || ''
  });
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const save = function () {
    setErr('');
    var payload = {
      salary_note: form.salary_note || null,
      default_salary: form.default_salary === '' ? null : Number(form.default_salary)
    };
    if (form.default_salary !== '' && (!isFinite(payload.default_salary) || payload.default_salary < 0)) { setErr('เงินเดือนต้อง >= 0'); return; }
    setSaving(true);
    API.put(E + '/' + props.data.empId + '/salaries/' + props.data.bizId, payload).then(props.onSaved)
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };

  const remove = function () {
    if (!window.confirm('ลบเงินเดือนสำหรับธุรกิจนี้?')) return;
    setSaving(true);
    API.delete(E + '/' + props.data.empId + '/salaries/' + props.data.bizId).then(props.onSaved)
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'ลบไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };

  return (
    <ModalShell title="ตั้งเงินเดือนต่อธุรกิจ" onClose={props.onClose}>
      <label style={lbl}>เงินเดือนฟิกซ์ (บาท/เดือน)</label>
      <input type="number" value={form.default_salary} onChange={function (e) { setForm(Object.assign({}, form, { default_salary: e.target.value })); }} style={inp} placeholder="ปล่อยว่างได้ ถ้าคิดเป็น %" />
      <label style={lbl}>หมายเหตุ (เช่น "8%", "ตามยอด")</label>
      <input value={form.salary_note} onChange={function (e) { setForm(Object.assign({}, form, { salary_note: e.target.value })); }} style={inp} />
      {err && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 8 }}>{err}</div>}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}>
        <div>
          {init.default_salary !== undefined && <button onClick={remove} style={Object.assign({}, btnSec, { color: '#ef4444', borderColor: '#fecaca' })} disabled={saving}>ลบ</button>}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={props.onClose} style={btnSec} disabled={saving}>ยกเลิก</button>
          <button onClick={save} style={btnPrimary} disabled={saving}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
        </div>
      </div>
    </ModalShell>
  );
}

// ============================================
// Modal shell
// ============================================
function ModalShell(props) {
  return (
    <div onClick={props.onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#fff', borderRadius: 12, padding: 20, width: '90%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>{props.title}</h3>
        {props.children}
      </div>
    </div>
  );
}
